__turbopack_context__.v({
  "fadeIn": "StackingSection-module__f6PSwW__fadeIn",
  "fadeInUp": "StackingSection-module__f6PSwW__fadeInUp",
  "fadeOut": "StackingSection-module__f6PSwW__fadeOut",
  "stackingContainer": "StackingSection-module__f6PSwW__stackingContainer",
  "stackingImagesModal": "StackingSection-module__f6PSwW__stackingImagesModal",
});
